import type { ReactNode } from "react";

export interface FieldProps {
  label?: string;
  /** Server-side or local validation message for this input. */
  error?: string | undefined;
  hint?: ReactNode;
  children: ReactNode;
}

/**
 * Label, control, and the message under it.
 *
 * The hint and the error deliberately sit outside the `<label>`: any text inside it
 * becomes part of the control's accessible name, which would have screen readers
 * announce the textarea as "Pozostało 300 z 300 znaków".
 */
export function Field({ label, error, hint, children }: FieldProps) {
  return (
    <div className="z-field">
      <label className="hub-field__control">
        {label ? <span className="hub-label">{label}</span> : null}
        {children}
      </label>
      {error ? <span className="z-field__error">{error}</span> : null}
      {!error && hint ? <span className="hub-hint">{hint}</span> : null}
    </div>
  );
}
